module.exports = __webpack_public_path__ + "static/media/icon-default.0ecb6426.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-default.svg
// module id = 402
// module chunks = 0